var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAustralia(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_7714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0028 12 0.00135937 12 0C18.6274 0 24 5.37262 24 12Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0C11.9993 0 11.9986 4.6875e-05 11.998 4.6875e-05L12 0Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9679 12H12C12 11.9891 12 11.9787 12 11.9679C11.9893 11.9786 11.9786 11.9893 11.9679 12Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6.26091C12 4.14942 12 2.76581 12 4.76837e-05H11.998C5.3715 0.00112581 0 5.37323 0 12H6.26086V8.47444L9.78642 12H11.9679C11.9787 11.9893 11.9894 11.9786 12 11.9679C12 11.1594 12 10.4381 12 9.78652L8.47444 6.26091H12Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.071 1.5652C4.19417 2.63391 2.63389 4.19419 1.56519 6.07102V12H4.69564V4.6957V4.69566H12C12 3.70833 12 2.76773 12 1.5652H6.071Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10.5243L7.73654 6.26095H6.26086C6.26086 6.26091 6.26086 6.26095 6.26086 6.26095L11.9999 12H12C12 12 12 10.9826 12 10.5243Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.23729 14.087L7.89588 15.4641L9.38309 15.1203L8.71709 16.4939L9.91305 17.4423L8.42398 17.7779L8.42815 19.3043L7.23729 18.3494L6.04648 19.3043L6.05065 17.7779L4.56152 17.4423L5.75754 16.4939L5.09145 15.1203L6.57874 15.4641L7.23729 14.087Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9665 16.6957L18.2958 17.3842L19.0394 17.2123L18.7063 17.8991L19.3044 18.3733L18.5598 18.5411L18.5619 19.3043L17.9665 18.8268L17.3711 19.3043L17.3731 18.5411L16.6286 18.3733L17.2266 17.8991L16.8936 17.2123L17.6372 17.3842L17.9665 16.6957Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9032 9.39131L15.2324 10.0799L15.976 9.90797L15.643 10.5947L16.241 11.069L15.4965 11.2368L15.4985 12L14.9032 11.5225L14.3077 12L14.3098 11.2368L13.5652 11.069L14.1632 10.5947L13.8302 9.90797L14.5739 10.0799L14.9032 9.39131Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9665 5.21737L18.2958 5.90597L19.0394 5.73408L18.7064 6.42084L19.3043 6.89503L18.5598 7.06289L18.5619 7.82611L17.9665 7.34859L17.3711 7.82611L17.3731 7.06289L16.6286 6.89503L17.2265 6.42084L16.8936 5.73408L17.6372 5.90597L17.9665 5.21737Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6423 8.34783L20.9715 9.03642L21.7152 8.86448L21.3822 9.55125L21.9801 10.0255L21.2356 10.1933L21.2376 10.9565L20.6423 10.479L20.0469 10.9565L20.0489 10.1933L19.3044 10.0255L19.9024 9.55125L19.5694 8.86448L20.3129 9.03642L20.6423 8.34783Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7289 12L18.9879 12.7972H19.8261L19.148 13.2899L19.4071 14.087L18.7289 13.5943L18.0508 14.087L18.3098 13.2899L17.6317 12.7972H18.4699L18.7289 12Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_7714"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAustralia);
export default __webpack_public_path__ + "static/media/australia.8d37af88fc4a8a63974a998c370de220.svg";
export { ForwardRef as ReactComponent };